import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import Input from "../form/Input";
import Button from "../form/Button";
import { postData } from "../../services/api";
import toastr from "toastr";
import { classNames } from "../../helper/classNames";
import Select from "../form/Select";

const BoardMemberFieldOptionPopup = ({
  isOpen,
  setIsOpen = () => {},
  label,
  fieldKey,
  data,
  loadList = () => {},
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [actionValue, setActionValue] = useState({});
  const [detailsId, setDetailsId] = useState("");

  const closeModal = () => {
    setIsOpen({ data: null, open: false });
    setName("");
  };

  useEffect(() => {
    setName(data?.name);
    setDetailsId(data?.row_id);
  }, [data]); 
  
  const onSubmit = async (e) => {
  setLoading(true);
  try {
    let path;
    let payload;
    const updatePaths = {
      study: "filter-item/update",
      expertise: "filter-item/update",
      industry: "industry/update"
    };

    const createPaths = {
      study: "filter-item/create",
      expertise: "filter-item/create",
      industry: "industry/create"
    };

    if (detailsId) {
      path = updatePaths[fieldKey];
      payload = { id: detailsId, name };
    } else {
      path = createPaths[fieldKey];
      if (fieldKey === "study") payload = { name, type: "study" };
      else if (fieldKey === "expertise") payload = { name, type: "area-expertise" };
      else if (fieldKey === "industry") payload = { name };
    }

    const result = await postData(path, payload);
    if (result.status === 200) {
      toastr.success(result.message);
      setIsOpen({ data: null, open: false });
      setActionValue({});
      loadList();
      closeModal();
    } else {
      toastr.error(result.message);
    }
  } catch (error) {
    toastr.error(error.message);
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <div className="relative z-50 overflow-hidden w-full">
        <div
          className={classNames(
            "fixed inset-0 bg-black bg-opacity-25 transition-all duration-300",
            isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          )}
        />
        <div
          className={classNames(
            "fixed inset-0 overflow-y-auto transition-transform duration-300",
            isOpen ? "opacity-100 visible" : "opacity-0 invisible"
          )}
        >
          <div className="flex h-screen justify-end w-full overflow-hidden">
            <div
              className={classNames(
                "w-full flex flex-col max-w-xl rounded-l-2xl p-4 bg-white text-left align-middle shadow-xl transition-all duration-300",
                isOpen ? "translate-x-0" : "translate-x-full"
              )}
            >
              <div className="relative flex-shrink-0">
                <h3 className="text-lg font-medium leading-6 text-gray-900 text-center mb-4">
                  {data?.row_id ? "Edit "+label : "Add "+label}
                </h3>
                <div className="absolute -top-4 -right-4 z-10">
                  <Button
                    buttonLabelClasses=""
                    buttonType={"button"}
                    buttonIcon={"fa-light fa-times"}
                    buttonIconPosition={"left"}
                    buttonLabel={""}
                    buttonClasses={
                      "!bg-transparent !text-slate-700 !w-10 !h-10 !p-0"
                    }
                    functions={() => {
                      closeModal();
                    }}
                    buttonHasLink={false}
                  />
                </div>
              </div>
              <div className="relative mt-4">
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-12 flex flex-col">
                    <div className="space-y-4">
                      <div className="grid grid-cols-1 gap-4">
                        <div className="relative w-full">
                          <Input
                            label={"Name"}
                            labelClasses={"!text-xs"}
                            inputType={"text"}
                            inputPlaceholder={"Enter Name"}
                            inputValue={name}
                            setInput={setName}
                            requiredDisplay={true}
                          />
                        </div>
                      </div>                      
                    </div>

                    <div className="flex justify-center gap-4 mt-8">
                      <div className="flex items-center justify-center gap-4">
                        <Button
                          buttonClasses={
                            "bg-white border border-slate-200 !text-slate-400 ml-2"
                          }
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={"fa-regular fa-xmark"}
                          buttonIconPosition={"left"}
                          buttonLabel={t("cancel")}
                          functions={() => {
                            closeModal();
                          }}
                          buttonHasLink={false}
                        />
                        <Button
                          buttonClasses=""
                          buttonLabelClasses=""
                          buttonType={"button"}
                          buttonIcon={
                            loading
                              ? "fa-light fa-spinner fa-spin"
                              : "fa-light fa-check"
                          }
                          buttonIconPosition={"left"}
                          buttonLabel={t("save")}
                          functions={onSubmit}
                          buttonHasLink={false}
                          buttonDisabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoardMemberFieldOptionPopup;
